module.exports = __webpack_public_path__ + "img/paul_04.114a9084.jpg";